import { createApp } from 'vue'
import VueLazyLoad from 'vue3-lazyload'
export default (app: ReturnType<typeof createApp>) => {
  app.use(VueLazyLoad, {
    error: '/img/default/pic-fallback.svg',
    loading: '/img/default/pic-none.jpg',
    observerOptions: {
      threshold: 0.5,
      rootMargin: '0px 0px 200px 0px'
    }
  })
}
